import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import SessionChecker from "./components/SessionChecker";
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './layout/MainLayout';
import AuthLayout from './layout/AuthLayout';
import Dashboard from './pages/Dashboard';
import Inventoryupload from './pages/Inventoryupload';
import Viewinventory from './pages/Viewinventory';
import InventoryList from './pages/InventoryList';
import Commodity from './pages/Commodity';
import Warehouse from './pages/Warehouse';
import Branch from './pages/Branch';
import Vendor from './pages/Vendor';
import City from "./pages/City";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import UpdatePasword from "./pages/UpdatePasword";
import BranchWarehouse from "./pages/BranchWarehouse";
import WarehouseStockList from "./pages/WarehouseStockList";
import CommodityStockList from "./pages/CommodityStockList";
import WhrList from "./pages/WhrList";
import Seasons from "./pages/Seasons";
import Purpose from "./pages/Purpose";
import GetStock from "./pages/GetStock";
import BlockStock from "./pages/BlockStock";
import Withdrawal from "./pages/Withdrawal";
import Withdrawalgetall from "./pages/Withdrawalgetall";
import Logs from "./pages/Logs";
import Particulars from "./pages/Particulars";
import MSP from "./pages/MSP";
import IncidentalRate from "./pages/IncidentalRate";
import BagSize from "./pages/BagSize";
import StoreIncidentalList from "./pages/StoreIncidentalList";
import StoreIncidentalForm from "./pages/StoreIncidentalForm";
import StoreIncidentalDetail from "./pages/StoreIncidentalDetail";
import IncidentalReports from "./pages/IncidentalReports";
import SlaList from "./pages/SlaList";
import SlaForm from "./pages/SlaForm";
import SlaDetail from "./pages/SlaDetail";
import ScheduleAuctionList from "./pages/ScheduleAuctionList";
import ScheduleAuctionCreate from "./pages/ScheduleAuctionCreate";

import { setNavigate } from "./utils/navigation";

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    // store navigate globally for axios interceptor redirects
    setNavigate(navigate);
  }, [navigate]);

  return (
    <>
      <SessionChecker />
      <Routes>
        {/* 🔓 Public (Auth) Routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
        </Route>

        {/* 🔒 Protected Routes (require login) */}
        <Route
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Dashboard />} />
          <Route path="/inventory/upload" element={<Inventoryupload />} />
          <Route path="/inventory/whrlist" element={<WhrList />} />
          <Route path="/inventory/view" element={<Viewinventory />} />
          <Route path="/inventory/list" element={<InventoryList />} />
          <Route path="/commodity" element={<Commodity />} />
          <Route path="/warehouse" element={<Warehouse />} />
          <Route path="/branch" element={<Branch />} />
          <Route path="/vendor" element={<Vendor />} />
          <Route path="/city" element={<City />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/update-password" element={<UpdatePasword />} />
          <Route path="/warehousebranch" element={<BranchWarehouse />} />
          <Route path="/inventory/warehousestoclist" element={<WarehouseStockList />} />
          <Route path="/inventory/commoditystocklist" element={<CommodityStockList />} />
          <Route path="/seasons" element={<Seasons />} />
          <Route path="/purposes" element={<Purpose />} />
          <Route path="/logs" element={<Logs />} />
          <Route path="/stock-blocking/get-all" element={<GetStock />} />
          <Route path="/stock-blocking/block-stock" element={<BlockStock />} />
          <Route path="/withdrawal/create" element={<Withdrawal />} />
          <Route path="/withdrawal/get-all" element={<Withdrawalgetall />} />
          <Route path="/particulars" element={<Particulars />} />
          <Route path="/msp" element={<MSP />} />
          <Route path="/incidental-rates" element={<IncidentalRate />} />
          <Route path="/bag-size" element={<BagSize />} />
          <Route path="/incidental/store" element={<StoreIncidentalList />} />
          <Route path="/incidental/store/create" element={<StoreIncidentalForm />} />
          <Route path="/incidental/store/:id" element={<StoreIncidentalDetail />} />
          <Route path="/incidental/store/:id/edit" element={<StoreIncidentalForm />} />
          <Route path="/incidental/reports" element={<IncidentalReports />} />
          <Route path="/incidental/sla" element={<SlaList />} />
          <Route path="/incidental/sla/create" element={<SlaForm />} />
          <Route path="/incidental/sla/:id" element={<SlaDetail />} />
          <Route path="/incidental/sla/:id/edit" element={<SlaForm />} />
          <Route path="/schedule-auction" element={<ScheduleAuctionList />} />
          <Route path="/schedule-auction/create" element={<ScheduleAuctionCreate />} />
        </Route>

        {/* 🔁 Catch-all: redirect unknown paths */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
}

export default App;
